/**
 * Production entry (apontamento) — an event of production against an OP
 * (spec 0040 §2.6 / request 0175).
 *
 * Top-level collection: org/{orgId}/production-entry (not a subcollection).
 * Transactional: Auditable, no Inactivatable.
 *
 * Anchoring is flexible: `productionOrderId` is required; `ticketId` is optional
 * (org param `production.requireTicket` can make it required). Where the work
 * happened (step / process / machine) is optional (`requireStep` likewise).
 *
 * No scrap (D5). Stock-ledger effect is F4 (`outputStockStatus`); origin of
 * movements is this entry (`sourceType: 'production-entry'`).
 */
export const PRODUCTION_ENTRY = 'ProductionEntry';
export const ProductionEntryOutputStockStatusValues = [
    'not-applicable',
    'pending',
    'posted',
];
export const PRODUCTION_ENTRY_OUTPUT_STOCK_STATUS_LABELS = {
    'not-applicable': 'Não se aplica',
    pending: 'Pendente',
    posted: 'Integrado',
};
//# sourceMappingURL=production-entry.js.map